export interface IGAAPI {
  track(eventName: string, props?: object): void;
}

// This branching prohibits this logging in tests by providing a no-op alternative to console.log
const devMock =
  process.env.NODE_ENV === 'development'
    ? (...bindArgs) =>
        (...args) =>
          // eslint-disable-next-line no-console
          console.log(...bindArgs.concat(args).filter((x) => x != null))
    : (function () {
        // it has to be a function expression and not an arrow function because `.bind` may be called on it
        return () => {};
      } as any);

export const DevMockGoogleAnalytics: IGAAPI = {
  track: devMock(null, 'heap:track')
};

export const GoogleAnalyticsAccessor = {
  track(eventName: string, props?: { path: string }): void {
    (window as any).ga('send', 'pageview', props.path);
  }
};

export const GoogleAnalyticsWrapper = !(window as any).ga ? DevMockGoogleAnalytics : GoogleAnalyticsAccessor;
